import React from "react"
import { graphql } from "gatsby"
import "bootstrap/dist/css/bootstrap.css"
import "./index.css"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Sidebar from "../components/sidebar/Sidebar"

const IndexPage = ({ data }) => {
  const post = data.markdownRemark
//   const labels = data.site.siteMetadata.labels
  return (
    <Layout>
      <SEO title="Category" keywords={[`gatsby`, `리액트`, `SSAFY`, `react`, `web development`, `블로그`, `웹 개발`]} />
      <div className="index-main">
        <div className="sidebar">
          <Sidebar />
        </div>
        <div className="post-main pl-3">
          <h1 className="fixed-top text-right muted-display">CATEGORY</h1>
          <div className="mt-3">
            <h1><span className="first-letter-deco">C</span>ATEGORY</h1>
            <p>포스트들을 종류별로 모아놓았습니다. </p>
            <br /><br />
            <h4>좌측의 사이드바 메뉴에서 아카이브를 누르시면 전체 보기를 하실 수 있습니다.</h4>
            <div dangerouslySetInnerHTML={{ __html: post.html }} />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
         query IndexQuery {
           site {
             siteMetadata {
               title 
               author
               labels {
                 tag
                 tech 
                 name 
                 size 
                 color
               } 
             }
           }
           markdownRemark(id: {eq: "5dca3d6f-52db-5c6a-a4a5-75fa9aa18d09"}) {
            id
            html
            frontmatter {
              title
              date(formatString: "YYYY년 MM일 DD일")
              tags
            }
          }
        }
      `
export default IndexPage
